import { render } from "./Header.vue?vue&type=template&id=7512bd2c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=7512bd2c&scoped=true&lang=css"

import exportComponent from "/Data/maps/detention/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7512bd2c"]])

export default __exports__